import React, { Component } from "react";
import { BiFlag } from "react-icons/bi";
import { FiMoreVertical, FiTrash } from "react-icons/fi";
import { GoComment } from "react-icons/go";
import { HiLocationMarker, HiReply } from "react-icons/hi";
import { Modal, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import ReportModal from "../../../base/features/blocks/ReportModal";
import Image from "../../../base/features/micro/Image";
import SimpleLabel from "../../../base/features/micro/SimpleLabel";
import Reply from "./Reply";
import { deleteComment, managementReply } from "./services";

class Comment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      commentMore: false,
      acceptDeleteModal: false,
      acceptReportModal: false,
      replyModal: false,
      type: "",
      replyComment: "",
    };
  }
  delete_comment() {
    this.setState({ acceptDeleteModal: false });
    deleteComment(this.props.comment.uid).then((items) => {
      Swal.fire({
        text: "با موفقعیت حذف شد",
        icon: "success",
        timer: 2000,
        confirmButtonText: "تایید",
      });
      this.props.get_comments();
    });
  }
  reply() {
    this.setState({ replyModal: false });
    managementReply(this.props.comment.uid, this.state.replyComment).then(
      (items) => {
        if (items) {
          Swal.fire({
            text: "با موفقعیت ثبت شد",
            icon: "success",
            timer: 2000,
            confirmButtonText: "تایید",
          });
          this.props.get_comments();
        }
      }
    );
  }
  render() {
    return (
      <div>
        <div className="row mx-0 border-bottom px-4 py-3">
          <div className="col-12 px-0">
            <div className="row mx-0">
              <div className="col-auto px-1">
                <Image
                  imageUri={this.props.comment.user.image}
                  imageHeight={"40"}
                  imageWidth={"40"}
                  imgClassName={"rounded28 img-cover"}
                  isProfile={true}
                  extraClassName={"p-0 img-contain"}
                />
              </div>
              <div className="col px-1 position-relative">
                <div className="row mx-0">
                  <div className="col px-0">
                    <p className="fw-bolder mb-0">
                      {this.props.comment.user.name}
                      {this.props.comment.user &&
                        this.props.comment.user.is_verify && (
                          <img
                            width="15"
                            className="me-1"
                            alt="verify"
                            src={
                              require("../../../base/assets/icons/verify.svg")
                                .default
                            }
                          />
                        )}
                    </p>
                    <p className="fw-bolder mb-0 fs-7 text-muted">
                      {this.props.comment.time}
                    </p>
                  </div>
                  {this.props.comment.private && (
                    <div className="col-auto px-0">
                      <span className="rounded-2 bg-color-second p-1 fs-7 text-white">
                        نظر شخصی
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {this.props.management && this.props.comment.product && (
            <div className="col-12 px-0 py-1">
              <span className="fs-6 fw-bold color-main">
                {this.props.comment.product.name}
              </span>
            </div>
          )}
          {this.props.management && this.props.comment.location && (
            <div className="col-12 px-0 py-1">
              <HiLocationMarker size={14} className="ms-2" />
              <span className="fs-6 fw-bold">
                {this.props.comment.location.title_fa}
              </span>
            </div>
          )}

          {this.props.comment.medias.map((media, m) => (
            <div className="col-4 px-1 py-2">
              <Image
                imageUri={media.file}
                imageHeight={"90"}
                imgClassName={"rounded-2 img-cover w-100"}
              />
            </div>
          ))}
          <div className="col-12 px-1 pb-3 pt-2">
            <p className="mb-0 overflow-hidden">{this.props.comment.comment}</p>
          </div>
          <div className="col-6 px-1">
            {this.props.management && (
              <span onClick={() => this.setState({ replyModal: true })}>
                <GoComment className="fw-bolder ms-2" size={20} />
                پاسخ
              </span>
            )}
          </div>
          {localStorage.getItem(`${window.location.hostname}_token`) && (
            <div className="col-6 px-1 text-start">
              <FiMoreVertical
                className="fw-bolder"
                size={20}
                onClick={() => this.setState({ commentMore: true })}
              />
            </div>
          )}
        </div>
        {this.props.comment.replies.length > 0 &&
          this.props.comment.replies.map((reply, r) => (
            <Reply
              reply={reply}
              get_comments={() => this.props.get_comments()}
            />
          ))}

        {this.state.commentMore && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
            isOpen={this.state.commentMore}
            toggle={() => this.setState({ commentMore: false })}
          >
            <ModalBody className="row mx-0 p-4">
              {this.props.comment.is_owner ? (
                <div
                  className="col-12 px-1 mb-4 text-danger fw-bolder"
                  onClick={() =>
                    this.setState({
                      type: "delete",
                      acceptDeleteModal: true,
                      commentMore: false,
                    })
                  }
                >
                  <FiTrash size={28} />
                  <span className="me-2 align-bottom">حذف</span>
                </div>
              ) : (
                <div
                  className="col-12 px-1 mb-4 text-dark-green fw-bolder"
                  onClick={() =>
                    this.setState({
                      type: "report",
                      acceptReportModal: true,
                      commentMore: false,
                    })
                  }
                >
                  <BiFlag size={28} />
                  <span className="me-2 align-bottom">گزارش تخلف</span>
                </div>
              )}

              <div className="col-12 px-1">
                <button
                  className="btn py-2 w-100 rounded28 border text-muted fw-bold"
                  onClick={() => this.setState({ commentMore: false })}
                >
                  انصراف
                </button>
              </div>
            </ModalBody>
          </Modal>
        )}
        {this.state.acceptReportModal && (
          <ReportModal
            uId={this.props.comment.uid}
            acceptReportModal={this.state.acceptReportModal}
            modalChange={(value) => this.setState({ acceptReportModal: value })}
            type={"comment"}
          />
        )}
        {this.state.acceptDeleteModal && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
            isOpen={this.state.acceptDeleteModal}
            toggle={() => this.setState({ acceptDeleteModal: false })}
          >
            <ModalBody className="row mx-0 p-4">
              <div className="col-12 px-1 mb-3">
                <p className="fw-bolder">حذف نظر</p>
                <p className="text-muted">
                  آیا برای حذف نظر خود اطمینان دارید؟
                </p>
              </div>

              <div className="col-6 px-1">
                <button
                  className="btn py-2 w-100 text-danger fw-bold"
                  onClick={() => this.delete_comment()}
                >
                  حذف
                </button>
              </div>
              <div className="col-6 px-1">
                <button
                  className="btn py-2 w-100 rounded28 border text-muted fw-bold"
                  onClick={() => this.setState({ acceptDeleteModal: false })}
                >
                  انصراف
                </button>
              </div>
            </ModalBody>
          </Modal>
        )}
        {this.state.replyModal && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
            isOpen={this.state.replyModal}
            toggle={() => this.setState({ replyModal: false })}
          >
            <ModalBody className="row mx-0 p-4">
              <div className="col-12 px-0 align-self-center">
                <HiReply
                  size={18}
                  className="color-main ms-2"
                  style={{ transform: "scaley(-1.5)" }}
                />
                <Image
                  imageUri={this.props.comment.user.image}
                  imageHeight={"40"}
                  imageWidth={"40"}
                  imgClassName={"rounded28 img-cover ms-2"}
                  extraClassName={
                    "rounded-circle p-2 d-inline-block bg-color-main ms-2"
                  }
                />
                <span className="fw-bolder">
                  {this.props.comment.user.name}
                </span>
              </div>
              <div className="col-12 px-0 py-3">
                <p className="mb-0 fw-bolder">{this.props.comment.comment}</p>
              </div>
              <div className="col-12 px-0 pb-3 position-relative">
                <textarea
                  className="form-control rounded14 p-3"
                  rows="4"
                  placeholder="پاسخ"
                  value={this.state.replyComment}
                  onChange={(e) =>
                    this.setState({ replyComment: e.target.value })
                  }
                />
                {this.state.replyComment && <SimpleLabel text="پاسخ" />}
              </div>
              <div className="col-12 px-0">
                <button
                  disabled={!this.state.replyComment}
                  onClick={() => this.reply()}
                  className="btn rounded28 w-100 bg-color-main fw-bold text-white"
                >
                  ارسال
                </button>
              </div>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

export default Comment;
